import {connect} from 'react-redux'
import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap'
import {withRouter} from 'react-router-dom'

import CommentsForm from '../../Forms/CommentsForm/CommentsForm.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Modal from '../../../../shared/components//Modals/Modal.jsx'
import SubmitButton from '../../Forms/CommentsForm/SubmitButton.jsx'

import api from '../../../../api.js'

class CommentsModal extends Modal {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    super.componentDidUpdate(prevProps, prevState, prevContext)
  }

  submit = (values) => {
    try {
      const isEdit = !!this.props.comment
      const newValues = {
        freelance: this.props.freelance.id,
        ...values,
      }

      if (isEdit) {
        newValues.note = this.props.comment.id
        return api.freelances.notes.edit(newValues)
      } else {
        return api.freelances.notes.add(newValues)
      }
    } catch (e) {
      console.warn(e)
    }
  }

  onSubmitSuccess = () => {
    this.props.closeModal(true)
    if (this.props.onFormSuccess) {
      this.props.onFormSuccess()
    }
  }

  render() {
    return (
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} className="modal-lg" backdrop="static">
        <Loader visible={!!this.state.loading}>Sauvegarde</Loader>
        <ModalHeader toggle={this.props.closeModal}>Commentaire</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <CommentsForm
                onSubmit={this.submit}
                onSubmitSuccess={this.onSubmitSuccess}
                initialValues={this.props.comment}
              />
              <div className="mt-5 d-flex">
                <SubmitButton className="mx-auto btn btn-primary">Sauvegarder</SubmitButton>
              </div>
            </div>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}

export default connect(
  state => ({
    currentUser: state.currentUser.user,
  })
)(withRouter(CommentsModal))